var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16,6.5c0-.945.381-1.803,1-2.433v-1.067c0-1.657,1.343-3,3-3v3.025c2.418.27,4,2.699,4,4.35,0,1.933-2.481,2.625-4.444,2.625s-3.556-1.567-3.556-3.5Zm1.982,9.016l.911-1.458c.477.588,1.122,1.046,1.882,1.3.758.253,1.482.619,2.151,1.087l1.146-1.639c-.827-.579-1.723-1.031-2.664-1.345-.696-.233-1.204-.797-1.359-1.472-.162.007-.327.011-.495.011-2.683,0-4.928-1.893-5.444-4.401-.604.487-1.423,1.019-2.147,1.489-.052.034-.615.401-.668.435-2.815,1.851-6.224,4.371-6.295,8.514l-.016-.029c-1.142-2.064-.924-4.65.638-6.417,1.091-1.234,2.516-2.407,3.742-3.257,1.001-.871,1.634-2.154,1.634-3.585,0-2.623-2.377-4.75-5-4.75C2.636-.067,0,2.651,0,6c0,7.615,2.983,12.78,4.266,14.647,1.442,2.099,3.841,3.353,6.419,3.353h11.315v-2h-4.537c.341-.589.537-1.272.537-2,0-2.206-1.794-4-4-4v-2c1.527,0,2.922.573,3.982,1.516Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.7f5e0150bee8712abcc2af7a1f0b2181.svg";
export { ForwardRef as ReactComponent };